import React from "react";
import summaryValues from "./functions/summaryValues";
import SummaryBar from "../../components/SummaryBar";
import { RootState } from "StoreTypes";
import { session } from "apex-legit-service";
import { connect } from "react-redux";
import styles from "./styles.module.scss";
import {
  fetchSummary,
  fetchSummaryLoading,
  fetchSummaryError,
} from "../../services/reports/selectors";
import { CFItem, DetailedError } from "../../types";
import { FormattedMessage } from "react-intl";
import messages from "../../components/Summary/messages";

export interface Props {
  summary: CFItem;
  loading: boolean;
  error: DetailedError;
}

const SummarySection = ({ summary, loading, error }: Props) => {
  const cfObj = summaryValues(
    "",
    "projected.total.total",
    "total.total",
    summary
  );

  const cfApexObj = summaryValues(
    "",
    "projected.apex-total.total",
    "total.total",
    summary
  );

  const mtmObj = summaryValues(
    "projected.mtm.sliceId",
    "projected.mtm.mtm-requirement-amount",
    "detail.mtm-requirement-amount",
    summary
  );

  const varObj = summaryValues(
    "projected.var.sliceId",
    "projected.var.var-requirement-amount",
    "detail.var-requirement-amount",
    summary
  );

  const varApexObj = summaryValues(
    "projected.apex-var.sliceId",
    "projected.apex-var.var-requirement-amount",
    "detail.var-requirement-amount",
    summary
  );

  const excess = summaryValues(
    "",
    "projected.total.excess",
    "total.excess",
    summary
  );

  const excessApex = summaryValues(
    "",
    "projected.apex-total.excess",
    "total.excess",
    summary
  );

  return (
    <div className={styles.padding}>
      {error.error && (
        <div className="ui error message" id={`summary-error`}>
          <div className="header">
            <FormattedMessage {...messages.errorHeader} />
          </div>
          <p>
            <FormattedMessage {...messages.errorBody} />
          </p>
        </div>
      )}
      <div className={`${error.error ? styles.summaryError : ""}`}>
        <SummaryBar
          date={Object.keys(summary).length === 0 ? "" : summary.curSlice.date}
          cfObj={cfObj}
          cfApexObj={cfApexObj}
          mtmObj={mtmObj}
          varObj={varObj}
          varApexObj={varApexObj}
          excess={excess}
          excessApex={excessApex}
          summary={summary}
          loading={loading}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: session.selectToken(state),
  summary: fetchSummary(state),
  error: fetchSummaryError(state),
  loading: fetchSummaryLoading(state),
});

export default connect(mapStateToProps)(SummarySection);
